<div class="alert-container">
    <div class="stats pt-6">
        <ng-container *ngFor="let stat of alertvarservice.stats | keyvalue:originalOrder">
            <div class="stats_wrapper border-light radius-m p-3 white-bg" [ngStyle]="{'border-left-color':stat.value.color}">
                <div class="stats-left">
                    <div class="stats-left-content">
                        <p class="m-0 content-m boldest-text" [ngStyle]="{'color':stat.value.color}">{{stat.value.disp}}</p>
                        <h2 class="m-0 boldest-text">{{alertvarservice.formatNumber(stat.value.count)}}</h2>
                    </div>
                    <div class="stats-right">
                        <div class="icon-wrapper radius-m p-1" [ngStyle]="{'background-color':stat.value['bg-color'],'border-color':stat.value['border-color']}">
                            <mat-icon [ngStyle]="{'color':stat.value.color}">{{stat.value.icon}}</mat-icon>
                        </div>
                    </div>

                </div>
                <div class="stats-left-footer">
                    <p class="m-0 content-s primary-text lightest-text">{{stat.value.percentage}}% of active alerts .</p>
                    <p class="m-0 content-s  lightest-text">{{ stat.value.diff ? '+' + alertvarservice.formatNumber(stat.value.diff) + ' from last hour' : 'No change' }}</p>
                </div>

            </div>
        </ng-container>
    </div>
    <div class="alert-filter-box">
        <div class="alert-filters">
            <div #stateFilter class="state-filter border-light py-2 px-4 hover-bg content-m primary-text radius-m white-bg enable-action">
                <mat-icon>assignment_ind</mat-icon>
                <app-overlay-select class=" px-2" [origin]="stateFilter" overlaycontainer="border-none shadow-none" [placeHolder]="alertvarservice.alert_tab_metadata.placeholders.state" [data]="sharedService.state_map" [formControl]="alertvarservice.alertStateFilter"
                    [hasMultiSelect]="true" sort="true"></app-overlay-select>
            </div>
            <div #timeFilter class="alert-status-time-filter border-light py-2 px-4 hover-bg content-m primary-text radius-m white-bg enable-action">
                <mat-icon>schedule</mat-icon>
                <app-overlay-select class="px-2" [origin]="timeFilter" overlaycontainer="border-none shadow-none" [data]="alertvarservice.time" [formControl]="alertvarservice.alertTimeFilter" sort="true"></app-overlay-select>
            </div>
            <div #severityFilter class="severity-filter border-light py-2 px-4 hover-bg content-m primary-text radius-m white-bg enable-action">
                <mat-icon>warning</mat-icon>
                <app-overlay-select class="wb-tab px-2" [origin]="severityFilter" overlaycontainer="border-none shadow-none" [placeHolder]="alertvarservice.alert_tab_metadata.placeholders.severity" [data]="sharedService.severity_map" [formControl]="alertvarservice.alertSeverityFilter"
                    [hasMultiSelect]="true" sort="true"></app-overlay-select>
            </div>
            <div #platformFilter class="platform-filter border-light py-2 px-4 hover-bg content-m primary-text radius-m white-bg enable-action">
                <mat-icon>layers</mat-icon>
                <app-overlay-select class="wb-tab px-2" [origin]="platformFilter" overlaycontainer="border-none shadow-none" [placeHolder]="alertvarservice.alert_tab_metadata.placeholders.platform" [data]="sharedService.platform_map" [formControl]="alertvarservice.alertPlatformFilter"
                    [hasMultiSelect]="true" sort="true"></app-overlay-select>
            </div>
            <div #analystFilter class="analyst-filter border-light py-2 px-4 hover-bg content-m primary-text radius-m white-bg enable-action">
                <mat-icon>person</mat-icon>
                <app-overlay-select [origin]="analystFilter" class="px-2" overlaycontainer="border-none shadow-none" [data]="sharedService.analystlist" [formControl]="alertvarservice.alertAnalystFilter"></app-overlay-select>
            </div>
        </div>
        <div *ngIf="alertvarservice.selectedGlobalFilters.length" class="selected-filters">
            <div class="selected-filter-header">
                <p class="content-m primary-text bold-text">{{alertvarservice.alert_tab_metadata.labels.selected_state}}:</p>
            </div>
            <div class="filter-chips">
                <ng-container *ngFor="let chip of alertvarservice.selectedGlobalFilters">
                    <div class="chip border-report radius-xl py-1 px-3 ">
                        <p class="content-m primary-text ">{{chip.disp}}</p>
                        <mat-icon class="primary-text enable-action content-xl " (click)="alertvarservice.removeFilter(chip)">close</mat-icon>
                    </div>
                </ng-container>
            </div>
            <div class="filter-reset">
                <p class="reset m-0 content-m primary-text enable-action" (click)="resetFilter()">{{alertvarservice.alert_tab_metadata.labels.clear_all}}</p>
            </div>
        </div>
    </div>
    <!-- <app-alert-status-tabs [selectedIndex]="alertvarservice.alertStatusSelectedIndex" (selectedIndexChange)="tabChange($event)">
        <alert-status-tab label="Triggered" [count]="getAlertTypeCount(0)" icon="notifications">
            <div class="landing-wrapper pt-7">
                <div class="pagination border-light radius-m p-3">
                    <div class="pagination-left"></div>
                    <div class="pagination-right">
                        <div class="expand primary-text white-bg radius-m p-1 border-light">
                            <mat-icon>unfold_more</mat-icon>
                        </div>
                        <div class="refresh primary-text white-bg radius-m p-1 border-light">
                            <mat-icon>refresh</mat-icon>
                        </div>
                        <div class="fullscreen primary-text white-bg radius-m p-1 border-light">
                            <mat-icon>fullscreen</mat-icon>
                        </div>
                    </div>
                </div>
                <div class="landing-body" *ngIf="!mat_landing_spinner && alertvarservice.triggeredRows.length">
                    <div class="banner-wrapper pt-4">
                        <ng-container *ngFor="let alert of alertvarservice.triggeredRows ; index as i">
                            <div class="accordian-wrapper">
                                <div class="acc-banner border-light radius-m p-4 white-bg">
                                    <div class="acc-left">
                                        <div class="acc-btn primary-text enable-action" (click)="openAccordian(alert.alertId,alertvarservice.triggeredRows)">
                                            <mat-icon>{{alert.accordian ? 'expand_more' : 'chevron_right'}}</mat-icon>
                                        </div>
                                        <div class="alert-id px-2 border-report radius-m">
                                            <p class="selectable-text content-m">{{alert.alertId}}</p>
                                        </div>
                                        <p class="primary-text alert-title content-m boldest-text tooltip-enable" [ngClass]="(sharedService.$sidebarExpanded | async) ? 'sidebar-close': 'sidebar-open'" [tooltip]="alert.alertTitle">{{alert.alertTitle}}</p>
                                        <div class="severity px-2 radius-m" [ngStyle]=alertvarservice.severity[alert.severity]>
                                            <p class="content-m ">{{alert.severity}}</p>
                                        </div>
                                    </div>
                                    <div class="acc-right ">
                                        <div class="percent primary-text">
                                            <p class="content-m lightest-text">Alert % </p>
                                            <p class="content-m boldest-text">{{getPercent(alert.alertcount,alertvarservice.triggeredRows)}}</p>
                                        </div>
                                        <div class=" split-line border-light-right"></div>
                                        <div class="alert-count primary-text">
                                            <mat-icon class="primary-text">warning</mat-icon>
                                            <p class="content-m lightest-text">Alerts:</p>
                                            <p class="content-m boldest-text">{{alertvarservice.formatNumber(alert.alertcount)}}</p>
                                        </div>
                                        <div class=" split-line border-light-right"></div>
                                        <div class="event-count primary-text">
                                            <mat-icon class="primary-text">analytics</mat-icon>
                                            <p class="content-m lightest-text">Events:</p>
                                            <p class="content-m boldest-text">{{alertvarservice.formatNumber(alert.eventcount)}}</p>
                                        </div>
                                        <div class=" split-line border-light-right"></div>
                                        <div class="last-seen primary-text">
                                            <mat-icon class="primary-text">access_time</mat-icon>
                                            <p class="content-m lightest-text">Last Seen:</p>
                                            <p class="content-m ">{{getLastSeen(alert.lastAlertTime)}}</p>
                                        </div>
                                        <div class="dedup selectable-text border-blue pl-2 py-1 pr-4 radius-m enable-action" (click)="openDedup(deduporigin,alert.alertId,alert.status)">
                                            <mat-icon class="content-xl">call_merge</mat-icon>
                                            <p class="content-m boldest-text">De-dup</p>
                                        </div>
                                        <div class="explore-alerts selectable-text border-blue px-2 py-1 radius-m enable-action" (click)="openFactsheet_click(alert)">
                                            <p class="content-m boldest-text">Explore Alert Graph</p>
                                        </div>
                                        <div #timeOrigin class="more primary-text border-light px-2 py-1 radius-m enable-action" (click)="openOverlay_templateRef(timeFilterRef,timeOrigin,i,alertvarservice.triggeredRows)">
                                            <mat-icon class="content-xl">more_vert</mat-icon>
                                        </div>
                                    </div>
                                </div>
                                <div class="acc-results border-light radius-m" *ngIf="alert.accordian">
                                    <app-event-panel [data]="alert"></app-event-panel>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                </div>
                <div class="no-result-container" *ngIf="!mat_landing_spinner && !alertvarservice.triggeredRows.length">
                    <img src="/assets/empty-data.svg">
                    <div class="no-data">No results found</div>
                </div>
                <ng-container *ngIf="mat_landing_spinner ">
                    <div class="spinner-wrapper ">
                        <mat-spinner class="loading light-text primary-text " diameter="15 "></mat-spinner>
                    </div>
                </ng-container>
            </div>
        </alert-status-tab>
        <alert-status-tab label="Acknowledged" [count]="getAlertTypeCount(1)" icon="check_circle_outline">
            <div class="landing-wrapper pt-7">
                <div class="pagination border-light radius-m p-3">
                    <div class="pagination-left"></div>
                    <div class="pagination-right">
                        <div class="expand primary-text white-bg radius-m p-1 border-light">
                            <mat-icon>unfold_more</mat-icon>
                        </div>
                        <div class="refresh primary-text white-bg radius-m p-1 border-light">
                            <mat-icon>refresh</mat-icon>
                        </div>
                        <div class="fullscreen primary-text white-bg radius-m p-1 border-light">
                            <mat-icon>fullscreen</mat-icon>
                        </div>
                    </div>
                </div>
                <div class="landing-body" *ngIf="!mat_landing_spinner && alertvarservice.ackRows.length">
                    <div class="banner-wrapper pt-4">
                        <ng-container *ngFor="let alert of alertvarservice.ackRows ; index as i">
                            <div class="accordian-wrapper">
                                <div class="acc-banner border-light radius-m p-4 white-bg">
                                    <div class="acc-left">
                                        <div class="acc-btn primary-text enable-action" (click)="openAccordian(alert.alertId,alertvarservice.ackRows)">
                                            <mat-icon>{{alert.accordian ? 'expand_more' : 'chevron_right'}}</mat-icon>
                                        </div>
                                        <div class="alert-id px-2 border-report radius-m">
                                            <p class="selectable-text content-m">{{alert.alertId}}</p>
                                        </div>
                                        <p class="primary-text alert-title content-m boldest-text tooltip-enable" [tooltip]="alert.alertTitle" [ngClass]="(sharedService.$sidebarExpanded | async) ? 'sidebar-close': 'sidebar-open'">{{alert.alertTitle}}</p>
                                        <div class="severity px-2 radius-m" [ngStyle]=alertvarservice.severity[alert.severity]>
                                            <p class="content-m ">{{alert.severity}}</p>
                                        </div>
                                    </div>
                                    <div class="acc-right ">
                                        <div class="percent primary-text">
                                            <p class="content-m lightest-text">Alert % </p>
                                            <p class="content-m boldest-text">{{getPercent(alert.alertcount,alertvarservice.ackRows)}}</p>
                                        </div>
                                        <div class=" split-line border-light-right"></div>
                                        <div class="alert-count primary-text">
                                            <mat-icon class="primary-text">warning</mat-icon>
                                            <p class="content-m lightest-text">Alerts:</p>
                                            <p class="content-m boldest-text">{{alertvarservice.formatNumber(alert.alertcount)}}</p>
                                        </div>
                                        <div class=" split-line border-light-right"></div>
                                        <div class="event-count primary-text">
                                            <mat-icon class="primary-text">analytics</mat-icon>
                                            <p class="content-m lightest-text">Events:</p>
                                            <p class="content-m boldest-text">{{alertvarservice.formatNumber(alert.eventcount)}}</p>
                                        </div>
                                        <div class=" split-line border-light-right"></div>
                                        <div class="last-seen primary-text">
                                            <mat-icon class="primary-text">access_time</mat-icon>
                                            <p class="content-m lightest-text">Last Seen:</p>
                                            <p class="content-m ">{{getLastSeen(alert.lastAlertTime)}}</p>
                                        </div>
                                        <div class="dedup selectable-text border-blue pl-2 py-1 pr-4 radius-m enable-action" (click)="openDedup(deduporigin,alert.alertId,alert.status)">
                                            <mat-icon class="content-xl">call_merge</mat-icon>
                                            <p class="content-m boldest-text">De-dup</p>
                                        </div>
                                        <div class="explore-alerts selectable-text border-blue px-2 py-1 radius-m enable-action" (click)="openFactsheet_click(alert)">
                                            <p class="content-m boldest-text">Explore Alert Graph</p>
                                        </div>
                                        <div #timeOrigin class="more primary-text border-light px-2 py-1 radius-m enable-action" (click)="openOverlay_templateRef(timeFilterRef,timeOrigin,i,alertvarservice.ackRows)">
                                            <mat-icon class="content-xl">more_vert</mat-icon>
                                        </div>
                                    </div>
                                </div>
                                <div class="acc-results border-light radius-m" *ngIf="alert.accordian">
                                    <app-event-panel [data]="alert"></app-event-panel>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                </div>
                <div class="no-result-container" *ngIf="!mat_landing_spinner && !alertvarservice.ackRows.length">
                    <img src="/assets/empty-data.svg">
                    <div class="no-data">No results found</div>
                </div>
                <ng-container *ngIf="mat_landing_spinner ">
                    <div class="spinner-wrapper ">
                        <mat-spinner class="loading light-text primary-text " diameter="15 "></mat-spinner>
                    </div>
                </ng-container>
            </div>
        </alert-status-tab>
        <alert-status-tab label="Waiting" [count]="getAlertTypeCount(3)" icon="schedule">
            <div class="landing-wrapper pt-7">
                <div class="pagination border-light radius-m p-3">
                    <div class="pagination-left"></div>
                    <div class="pagination-right">
                        <div class="expand primary-text white-bg radius-m p-1 border-light">
                            <mat-icon>unfold_more</mat-icon>
                        </div>
                        <div class="refresh primary-text white-bg radius-m p-1 border-light">
                            <mat-icon>refresh</mat-icon>
                        </div>
                        <div class="fullscreen primary-text white-bg radius-m p-1 border-light">
                            <mat-icon>fullscreen</mat-icon>
                        </div>
                    </div>
                </div>
                <div class="landing-body" *ngIf="!mat_landing_spinner && alertvarservice.waitingRows.length">
                    <div class="banner-wrapper pt-4">
                        <ng-container *ngFor="let alert of alertvarservice.waitingRows ; index as i">
                            <div class="accordian-wrapper">
                                <div class="acc-banner border-light radius-m p-4 white-bg">
                                    <div class="acc-left">
                                        <div class="acc-btn primary-text enable-action" (click)="openAccordian(alert.alertId,alertvarservice.waitingRows)">
                                            <mat-icon>{{alert.accordian ? 'expand_more' : 'chevron_right'}}</mat-icon>
                                        </div>
                                        <div class="alert-id px-2 border-report radius-m">
                                            <p class="selectable-text content-m">{{alert.alertId}}</p>
                                        </div>
                                        <p class="primary-text alert-title content-m boldest-text tooltip-enable" [tooltip]="alert.alertTitle" [ngClass]="(sharedService.$sidebarExpanded | async) ? 'sidebar-close': 'sidebar-open'">{{alert.alertTitle}}</p>
                                        <div class="severity px-2 radius-m" [ngStyle]=alertvarservice.severity[alert.severity]>
                                            <p class="content-m ">{{alert.severity}}</p>
                                        </div>
                                    </div>
                                    <div class="acc-right ">
                                        <div class="percent primary-text">
                                            <p class="content-m lightest-text">Alert % </p>
                                            <p class="content-m boldest-text">{{getPercent(alert.alertcount,alertvarservice.waitingRows)}}</p>
                                        </div>
                                        <div class=" split-line border-light-right"></div>
                                        <div class="alert-count primary-text">
                                            <mat-icon class="primary-text">warning</mat-icon>
                                            <p class="content-m lightest-text">Alerts:</p>
                                            <p class="content-m boldest-text">{{alertvarservice.formatNumber(alert.alertcount)}}</p>
                                        </div>
                                        <div class=" split-line border-light-right"></div>
                                        <div class="event-count primary-text">
                                            <mat-icon class="primary-text">analytics</mat-icon>
                                            <p class="content-m lightest-text">Events:</p>
                                            <p class="content-m boldest-text">{{alertvarservice.formatNumber(alert.eventcount)}}</p>
                                        </div>
                                        <div class=" split-line border-light-right"></div>
                                        <div class="last-seen primary-text">
                                            <mat-icon class="primary-text">access_time</mat-icon>
                                            <p class="content-m lightest-text">Last Seen:</p>
                                            <p class="content-m ">{{getLastSeen(alert.lastAlertTime)}}</p>
                                        </div>
                                        <div class="dedup selectable-text border-blue pl-2 py-1 pr-4 radius-m enable-action" (click)="openDedup(deduporigin,alert.alertId,alert.status)">
                                            <mat-icon class="content-xl">call_merge</mat-icon>
                                            <p class="content-m boldest-text">De-dup</p>
                                        </div>
                                        <div class="explore-alerts selectable-text border-blue px-2 py-1 radius-m enable-action" (click)="openFactsheet_click(alert)">
                                            <p class="content-m boldest-text">Explore Alert Graph</p>
                                        </div>
                                        <div #timeOrigin class="more primary-text border-light px-2 py-1 radius-m enable-action" (click)="openOverlay_templateRef(timeFilterRef,timeOrigin,i,alertvarservice.waitingRows)">
                                            <mat-icon class="content-xl">more_vert</mat-icon>
                                        </div>
                                    </div>
                                </div>
                                <div class="acc-results border-light radius-m" *ngIf="alert.accordian">
                                    <app-event-panel [data]="alert"></app-event-panel>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                </div>
                <div class="no-result-container" *ngIf="!mat_landing_spinner && !alertvarservice.waitingRows.length">
                    <img src="/assets/empty-data.svg">
                    <div class="no-data">No results found</div>
                </div>
                <ng-container *ngIf="mat_landing_spinner ">
                    <div class="spinner-wrapper ">
                        <mat-spinner class="loading light-text primary-text " diameter="15 "></mat-spinner>
                    </div>
                </ng-container>
            </div>
        </alert-status-tab>
        <alert-status-tab label="Re-assigned" [count]="getAlertTypeCount(4)" icon="swap_horiz">
            <div class="landing-wrapper pt-7">
                <div class="pagination border-light radius-m p-3">
                    <div class="pagination-left"></div>
                    <div class="pagination-right">
                        <div class="expand primary-text white-bg radius-m p-1 border-light">
                            <mat-icon>unfold_more</mat-icon>
                        </div>
                        <div class="refresh primary-text white-bg radius-m p-1 border-light">
                            <mat-icon>refresh</mat-icon>
                        </div>
                        <div class="fullscreen primary-text white-bg radius-m p-1 border-light">
                            <mat-icon>fullscreen</mat-icon>
                        </div>
                    </div>
                </div>
                <div class="landing-body" *ngIf="!mat_landing_spinner && alertvarservice.reassignRows.length">
                    <div class="banner-wrapper pt-4">
                        <ng-container *ngFor="let alert of alertvarservice.reassignRows ; index as i">
                            <div class="accordian-wrapper">
                                <div class="acc-banner border-light radius-m p-4 white-bg">
                                    <div class="acc-left">
                                        <div class="acc-btn primary-text enable-action" (click)="openAccordian(alert.alertId,alertvarservice.reassignRows)">
                                            <mat-icon>{{alert.accordian ? 'expand_more' : 'chevron_right'}}</mat-icon>
                                        </div>
                                        <div class="alert-id px-2 border-report radius-m">
                                            <p class="selectable-text content-m">{{alert.alertId}}</p>
                                        </div>
                                        <p class="primary-text alert-title content-m boldest-text tooltip-enable" [tooltip]="alert.alertTitle" [ngClass]="(sharedService.$sidebarExpanded | async) ? 'sidebar-close': 'sidebar-open'">{{alert.alertTitle}}</p>
                                        <div class="severity px-2 radius-m" [ngStyle]=alertvarservice.severity[alert.severity]>
                                            <p class="content-m ">{{alert.severity}}</p>
                                        </div>
                                    </div>
                                    <div class="acc-right ">
                                        <div class="percent primary-text">
                                            <p class="content-m lightest-text">Alert % </p>
                                            <p class="content-m boldest-text">{{getPercent(alert.alertcount,alertvarservice.reassignRows)}}</p>
                                        </div>
                                        <div class=" split-line border-light-right"></div>
                                        <div class="alert-count primary-text">
                                            <mat-icon class="primary-text">warning</mat-icon>
                                            <p class="content-m lightest-text">Alerts:</p>
                                            <p class="content-m boldest-text">{{alertvarservice.formatNumber(alert.alertcount)}}</p>
                                        </div>
                                        <div class=" split-line border-light-right"></div>
                                        <div class="event-count primary-text">
                                            <mat-icon class="primary-text">analytics</mat-icon>
                                            <p class="content-m lightest-text">Events:</p>
                                            <p class="content-m boldest-text">{{alertvarservice.formatNumber(alert.eventcount)}}</p>
                                        </div>
                                        <div class=" split-line border-light-right"></div>
                                        <div class="last-seen primary-text">
                                            <mat-icon class="primary-text">access_time</mat-icon>
                                            <p class="content-m lightest-text">Last Seen:</p>
                                            <p class="content-m ">{{getLastSeen(alert.lastAlertTime)}}</p>
                                        </div>
                                        <div class="dedup selectable-text border-blue pl-2 py-1 pr-4 radius-m enable-action" (click)="openDedup(deduporigin,alert.alertId,alert.status)">
                                            <mat-icon class="content-xl">call_merge</mat-icon>
                                            <p class="content-m boldest-text">De-dup</p>
                                        </div>
                                        <div class="explore-alerts selectable-text border-blue px-2 py-1 radius-m enable-action" (click)="openFactsheet_click(alert)">
                                            <p class="content-m boldest-text">Explore Alert Graph</p>
                                        </div>
                                        <div #timeOrigin class="more primary-text border-light px-2 py-1 radius-m enable-action" (click)="openOverlay_templateRef(timeFilterRef,timeOrigin,i,alertvarservice.reassignRows)">
                                            <mat-icon class="content-xl">more_vert</mat-icon>
                                        </div>
                                    </div>
                                </div>
                                <div class="acc-results border-light radius-m" *ngIf="alert.accordian">
                                    <app-event-panel [data]="alert"></app-event-panel>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                </div>
                <div class="no-result-container" *ngIf="!mat_landing_spinner && !alertvarservice.reassignRows.length">
                    <img src="/assets/empty-data.svg">
                    <div class="no-data">No results found</div>
                </div>
                <ng-container *ngIf="mat_landing_spinner ">
                    <div class="spinner-wrapper ">
                        <mat-spinner class="loading light-text primary-text " diameter="15 "></mat-spinner>
                    </div>
                </ng-container>
            </div>
        </alert-status-tab>
        <alert-status-tab label="All" [count]="getAlertTypeCount(6)" icon="list">
            <div class="landing-wrapper pt-7">
                <div class="pagination border-light radius-m p-3">
                    <div class="pagination-left"></div>
                    <div class="pagination-right">
                        <div class="expand primary-text white-bg radius-m p-1 border-light">
                            <mat-icon>unfold_more</mat-icon>
                        </div>
                        <div class="refresh primary-text white-bg radius-m p-1 border-light">
                            <mat-icon>refresh</mat-icon>
                        </div>
                        <div class="fullscreen primary-text white-bg radius-m p-1 border-light">
                            <mat-icon>fullscreen</mat-icon>
                        </div>
                    </div>
                </div>
                <div class="landing-body" *ngIf="!mat_landing_spinner && alertvarservice.alltabRows.length">
                    <div class="banner-wrapper pt-4">
                        <ng-container *ngFor="let alert of alertvarservice.alltabRows ; index as i">
                            <div class="accordian-wrapper">
                                <div class="acc-banner border-light radius-m p-4 white-bg">
                                    <div class="acc-left">
                                        <div class="acc-btn primary-text enable-action" (click)="openAccordian(alert.alertId,alertvarservice.alltabRows)">
                                            <mat-icon>{{alert.accordian ? 'expand_more' : 'chevron_right'}}</mat-icon>
                                        </div>
                                        <div class="alert-id px-2 border-report radius-m">
                                            <p class="selectable-text content-m">{{alert.alertId}}</p>
                                        </div>
                                        <p class="primary-text alert-title content-m boldest-text tooltip-enable" [tooltip]="alert.alertTitle" [ngClass]="(sharedService.$sidebarExpanded | async) ? 'sidebar-close': 'sidebar-open'">{{alert.alertTitle}}</p>
                                        <div class="severity px-2 radius-m" [ngStyle]=alertvarservice.severity[alert.severity]>
                                            <p class="content-m ">{{alert.severity}}</p>
                                        </div>
                                    </div>
                                    <div class="acc-right ">
                                        <div class="percent primary-text">
                                            <p class="content-m lightest-text">Alert % </p>
                                            <p class="content-m boldest-text">{{getPercent(alert.alertcount,alertvarservice.alltabRows)}}</p>
                                        </div>
                                        <div class=" split-line border-light-right"></div>
                                        <div class="alert-count primary-text">
                                            <mat-icon class="primary-text">warning</mat-icon>
                                            <p class="content-m lightest-text">Alerts:</p>
                                            <p class="content-m boldest-text">{{alertvarservice.formatNumber(alert.alertcount)}}</p>
                                        </div>
                                        <div class=" split-line border-light-right"></div>
                                        <div class="event-count primary-text">
                                            <mat-icon class="primary-text">analytics</mat-icon>
                                            <p class="content-m lightest-text">Events:</p>
                                            <p class="content-m boldest-text">{{alertvarservice.formatNumber(alert.eventcount)}}</p>
                                        </div>
                                        <div class=" split-line border-light-right"></div>
                                        <div class="last-seen primary-text">
                                            <mat-icon class="primary-text">access_time</mat-icon>
                                            <p class="content-m lightest-text">Last Seen:</p>
                                            <p class="content-m ">{{getLastSeen(alert.lastAlertTime)}}</p>
                                        </div>
                                        <div class="dedup selectable-text border-blue pl-2 py-1 pr-4 radius-m enable-action" (click)="openDedup(deduporigin,alert.alertId,alert.status)">
                                            <mat-icon class="content-xl">call_merge</mat-icon>
                                            <p class="content-m boldest-text">De-dup</p>
                                        </div>
                                        <div class="explore-alerts selectable-text border-blue px-2 py-1 radius-m enable-action" (click)="openFactsheet_click(alert)">
                                            <p class="content-m boldest-text">Explore Alert Graph</p>
                                        </div>
                                        <div #timeOrigin class="more primary-text border-light px-2 py-1 radius-m enable-action" (click)="openOverlay_templateRef(timeFilterRef,timeOrigin,i,alertvarservice.alltabRows)">
                                            <mat-icon class="content-xl">more_vert</mat-icon>
                                        </div>
                                    </div>
                                </div>
                                <div class="acc-results border-light radius-m" *ngIf="alert.accordian">
                                    <app-event-panel [data]="alert"></app-event-panel>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                </div>
                <div class="no-result-container" *ngIf="!mat_landing_spinner && !alertvarservice.alltabRows.length">
                    <img src="/assets/empty-data.svg">
                    <div class="no-data">No results found</div>
                </div>
                <ng-container *ngIf="mat_landing_spinner ">
                    <div class="spinner-wrapper ">
                        <mat-spinner class="loading light-text primary-text " diameter="15 "></mat-spinner>
                    </div>
                </ng-container>
            </div>
        </alert-status-tab>
    </app-alert-status-tabs> -->
    <div class="landing-wrapper" [ngClass]="isSummaryFullscreen ? 'fullScreen white-bg p-4' : 'minScreen'">
        <div class="pagination border-light radius-m p-3">
            <div class="pagination-left">
                <!-- <div class="page-number-container"></div> -->
                <div class="prev-page enable-action border-light white-bg radius-m p-1">
                    <mat-icon (click)="gotoPage(-1)" [ngClass]="alertvarservice.alertSummaryPageNumber | disableAction:alertvarservice.alertSummaryPageLength:-1:mat_landing_spinner">chevron_left</mat-icon>
                </div>
                <div class="page-info">
                    <p class="m-0 content-m primary-text ">Page {{alertvarservice.alertSummaryPageNumber}} of {{alertvarservice.alertSummaryPageLength}}</p>
                </div>
                <div class="next-page  enable-action border-light white-bg radius-m p-1">
                    <mat-icon (click)="gotoPage(1)" [ngClass]="alertvarservice.alertSummaryPageNumber | disableAction:alertvarservice.alertSummaryPageLength:1:mat_landing_spinner">chevron_right</mat-icon>
                </div>
                <div class="itemsper-page-container">
                    <p class="m-0 content-m primary-text ">Items per page:</p>
                    <div #paginationOrigin class="items-per-page-list border-light white-bg radius-m  enable-action p-2">
                        <app-overlay-select [origin]="paginationOrigin" class="item-overlay" overlaycontainer="border-none shadow-none" [data]="alertvarservice.itemsPerpageValueList" [formControl]="alertvarservice.alertSummaryItemPerPage" sort="true"></app-overlay-select>
                    </div>
                </div>

            </div>
            <div class="pagination-right">
                <!-- <div class="expand primary-text white-bg radius-m p-1 border-light not-allowed">
                    <mat-icon>unfold_more</mat-icon>
                </div> -->
                <div class="refresh primary-text white-bg radius-m p-1 border-light enable-action tooltip-enable" [ngClass]="!mat_landing_spinner? 'enable-action':'permission-denied'" tooltip="Refresh" (click)="refreshAlertSummary()">
                    <mat-icon>refresh</mat-icon>
                </div>
                <div class="fullscreen primary-text white-bg radius-m p-1 border-light enable-action tooltip-enable" [tooltip]="!isSummaryFullscreen ?'Full Screen' : 'Exit Full Screen'" (click)="openFullscreenAlertSummary()">
                    <mat-icon>{{!isSummaryFullscreen ?'fullscreen' : 'fullscreen_exit'}}</mat-icon>
                </div>
            </div>
        </div>
        <div class="landing-body" *ngIf="!mat_landing_spinner && alertvarservice.allRows.length">
            <div class="banner-wrapper pt-6">
                <ng-container *ngFor="let alert of alertvarservice.allRows | custompagination :alertvarservice.alertSummaryPageNumber:alertvarservice.alertSummaryItemPerPage.value; index as i">
                    <div class="accordian-wrapper">
                        <div class="acc-banner border-light radius-m p-6 white-bg">
                            <div class="acc-left">
                                <div class="acc-btn primary-text enable-action" (click)="openAccordian(alert.alertId,alertvarservice.allRows)">
                                    <mat-icon>{{alert.accordian ? 'expand_more' : 'chevron_right'}}</mat-icon>
                                </div>
                                <div class="alert-id px-2 border-report radius-m">
                                    <p class="selectable-text content-m">{{alert.alertId}}</p>
                                </div>
                                <p class="primary-text alert-title content-m boldest-text tooltip-enable" [ngClass]="(sharedService.$sidebarExpanded | async) ? 'sidebar-close': 'sidebar-open'" [tooltip]="alert.alertTitle">{{alert.alertTitle}}</p>
                                <div class="severity px-2 radius-m" [ngStyle]=alertvarservice.severity[alert.severity]>
                                    <p class="content-m ">{{alert.severity | titlecase}}</p>
                                </div>
                            </div>
                            <div class="acc-right ">
                                <div class="percent primary-text">
                                    <p class="content-m lightest-text">Alert % </p>
                                    <p class="content-m boldest-text">{{getPercent(alert.alertcount,alertvarservice.allRows)}}</p>
                                </div>
                                <div class=" split-line border-light-right"></div>
                                <div class="alert-count primary-text">
                                    <mat-icon class="primary-text ">warning</mat-icon>
                                    <p class="content-m lightest-text">Alerts:</p>
                                    <p class="content-m boldest-text">{{alertvarservice.formatNumber(alert.alertcount)}}</p>
                                </div>
                                <div class=" split-line border-light-right"></div>
                                <div class="event-count primary-text">
                                    <mat-icon class="primary-text ">analytics</mat-icon>
                                    <p class="content-m lightest-text">Events:</p>
                                    <p class="content-m boldest-text">{{alertvarservice.formatNumber(alert.eventcount)}}</p>
                                </div>
                                <div class=" split-line border-light-right"></div>
                                <div class="last-seen primary-text">
                                    <mat-icon class="primary-text ">access_time</mat-icon>
                                    <p class="content-m lightest-text">Last Seen:</p>
                                    <p class="content-m ">{{getLastSeen(alert.lastAlertTime)}}</p>
                                </div>
                                <div class="dedup selectable-text border-blue pl-2 py-1 pr-4 radius-m" (click)="openDedup(deduporigin,alert.alertId,alert.status)" [ngClass]="sharedService.getCurrentUserId() == alertvarservice.getAnalystFilterValue() ? 'enable-action' : 'not-allowed'">
                                    <mat-icon class="content-xl">call_merge</mat-icon>
                                    <p class="content-m boldest-text">De-dup</p>
                                </div>
                                <div class="explore-alerts selectable-text border-blue px-4 py-1 radius-m enable-action" (click)="openFactsheet_click(alert)">
                                    <p class="content-m boldest-text">Explore Alert Graph</p>
                                </div>
                                <div #timeOrigin class="more hide primary-text border-light px-2 py-1 radius-m enable-action" (click)="openOverlay_templateRef(timeFilterRef,timeOrigin,i,alertvarservice.allRows)">
                                    <mat-icon class="content-xl">more_vert</mat-icon>
                                </div>
                            </div>
                        </div>
                        <div class="acc-results border-light radius-m" *ngIf="alert.accordian">
                            <app-event-panel [data]="alert" (updateSummary)="updateSummary($event)"></app-event-panel>
                        </div>
                    </div>
                </ng-container>
            </div>

        </div>
        <div class="no-result-container" *ngIf="!mat_landing_spinner && !alertvarservice.allRows.length">
            <img src="/assets/empty-data.svg">
            <div class="no-data">No results found</div>
        </div>
        <ng-container *ngIf="mat_landing_spinner ">
            <div class="spinner-wrapper ">
                <mat-spinner class="loading light-text primary-text " diameter="15 "></mat-spinner>
            </div>
        </ng-container>
    </div>
</div>

<ng-template #deduppop let-dialogRef="dialogRef">
    <mat-dialog-content class="p-0 m-0">
        <div class="dialog-container">
            <app-de-dup></app-de-dup>
        </div>
    </mat-dialog-content>
</ng-template>

<ng-template #timeFilterRef>
    <div class="timeFilter p-4 white-bg radius-m border-light">
        <div class="time">
            <p class="content-m primary-text boldest-text">Time</p>
            <div class="overlay-wrapper p-2 border-light radius-m">
                <app-overlay-select sort=true overlaycontainer="shadow-none border-none" fontsize="shadow-none border-none" [data]="alertvarservice.time" [formControl]="timeFilter"></app-overlay-select>
            </div>
        </div>
    </div>
</ng-template>